class AccordionBlock extends HTMLElement {
  constructor() {
    super()

    this.contents = this.querySelector('.js-accordions-group__block-content')
    this.action = this.querySelector(".accordions-group__block-header")
    this.action.addEventListener('click', this._onClick.bind(this))
  }

  _onClick(event) {
    event.preventDefault()

    this.classList.toggle('accordions-group__block-show')

    if (this.classList.contains('accordions-group__block-show')) {
      this.contents.style.maxHeight = `${this.contents.scrollHeight}px`
    } else {
      this.contents.style = ''
    }
  }
}

customElements.define('accordion-block', AccordionBlock)
